var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_2186)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.676 21.9403C15.6782 21.9834 15.6713 22.0265 15.6555 22.0669C15.6398 22.1074 15.6156 22.1443 15.5844 22.1756C15.5532 22.2068 15.5157 22.2317 15.4741 22.2487C15.4326 22.2656 15.3878 22.2744 15.3426 22.2743H11.6655C11.515 22.2745 11.3688 22.2262 11.2508 22.1371C11.1328 22.048 11.0498 21.9234 11.0154 21.7836C10.9939 21.688 10.9949 21.5889 11.0183 21.4937C11.0416 21.3984 11.0867 21.3092 11.1504 21.2325C11.7386 20.4882 12.5191 19.9021 13.4157 19.5315C13.0221 19.1891 12.7202 18.7617 12.5353 18.285C12.3504 17.8084 12.2879 17.2964 12.3531 16.792C12.4182 16.2876 12.609 15.8054 12.9096 15.3858C13.2102 14.9662 13.6118 14.6215 14.0808 14.3805C14.5497 14.1394 15.0724 14.0091 15.605 14.0005C16.1375 13.9918 16.6645 14.105 17.1418 14.3307C17.6191 14.5563 18.0328 14.8878 18.3482 15.2973C18.6636 15.7069 18.8716 16.1826 18.9547 16.6846C18.9654 16.7521 18.9528 16.8211 18.9186 16.8811C18.8845 16.9411 18.8307 16.9888 18.7655 17.017C17.8407 17.4249 17.0575 18.0768 16.5083 18.8956C15.9591 19.7144 15.6668 20.666 15.666 21.6381C15.666 21.7399 15.666 21.8401 15.676 21.9403ZM30.8445 21.2317C30.2576 20.4883 29.4789 19.9025 28.5842 19.5315C28.9778 19.1891 29.2797 18.7617 29.4646 18.285C29.6495 17.8084 29.712 17.2964 29.6469 16.792C29.5817 16.2876 29.3909 15.8054 29.0903 15.3858C28.7897 14.9662 28.3881 14.6215 27.9191 14.3805C27.4502 14.1394 26.9275 14.0091 26.395 14.0005C25.8624 13.9918 25.3354 14.105 24.8581 14.3307C24.3808 14.5563 23.9671 14.8878 23.6517 15.2973C23.3363 15.7069 23.1283 16.1826 23.0452 16.6846C23.0345 16.7521 23.0472 16.8211 23.0813 16.8811C23.1155 16.9411 23.1692 16.9888 23.2344 17.017C24.1592 17.4249 24.9424 18.0768 25.4916 18.8956C26.0408 19.7144 26.3331 20.666 26.334 21.6381C26.334 21.7399 26.334 21.8401 26.324 21.9403C26.3217 21.9834 26.3286 22.0265 26.3444 22.0669C26.3601 22.1074 26.3843 22.1443 26.4155 22.1756C26.4467 22.2068 26.4842 22.2317 26.5258 22.2487C26.5674 22.2656 26.6121 22.2744 26.6573 22.2743H30.3345C30.4849 22.2745 30.6311 22.2262 30.7491 22.1371C30.8671 22.048 30.9501 21.9234 30.9845 21.7836C31.0061 21.6878 31.0051 21.5886 30.9816 21.4931C30.9581 21.3977 30.9127 21.3084 30.8487 21.2317H30.8445ZM23.4269 24.6656C24.0908 24.1805 24.5787 23.509 24.822 22.7457C25.0653 21.9823 25.0517 21.1654 24.7833 20.4098C24.5149 19.6541 24.0051 18.9977 23.3255 18.5328C22.6459 18.068 21.8307 17.8179 20.9945 17.8179C20.1583 17.8179 19.3432 18.068 18.6636 18.5328C17.984 18.9977 17.4742 19.6541 17.2057 20.4098C16.9373 21.1654 16.9238 21.9823 17.1671 22.7457C17.4104 23.509 17.8983 24.1805 18.5622 24.6656C17.3841 25.1526 16.4004 25.9867 15.7551 27.0457C15.6966 27.1424 15.6658 27.2522 15.6658 27.3638C15.6658 27.4755 15.6966 27.5853 15.7552 27.682C15.8137 27.7787 15.8979 27.859 15.9993 27.9148C16.1007 27.9706 16.2157 28 16.3327 28H25.6672C25.7843 28 25.8993 27.9706 26.0006 27.9148C26.102 27.859 26.1862 27.7787 26.2447 27.682C26.3033 27.5853 26.3341 27.4755 26.3341 27.3638C26.3341 27.2522 26.3033 27.1424 26.2448 27.0457C25.5981 25.986 24.6126 25.1518 23.4328 24.6656H23.4269Z",
    fill: "#0F5EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_2186",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_24424_2186"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_2186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_2186",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.34c6b008f4b4439250eedcdb49d71932.svg";
export { ForwardRef as ReactComponent };